var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertageCheckmar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8749 26.7083C83.0791 27.8467 83.7819 29.4168 83.8288 31.0732C83.8757 32.7297 83.2628 34.337 82.1249 35.5417L46.7083 73.0417C46.1343 73.6483 45.4445 74.1338 44.6797 74.4694C43.9149 74.805 43.0906 74.9839 42.2555 74.9956C41.4204 75.0072 40.5914 74.8514 39.8176 74.5373C39.0437 74.2231 38.3406 73.7571 37.7499 73.1667L18.9999 54.4167C17.8959 53.2319 17.2949 51.6648 17.3235 50.0456C17.3521 48.4265 18.008 46.8816 19.1531 45.7365C20.2982 44.5914 21.8431 43.9354 23.4623 43.9069C25.0814 43.8783 26.6485 44.4793 27.8333 45.5833L42.0416 59.7833L73.0416 26.9583C74.18 25.7541 75.7501 25.0513 77.4065 25.0045C79.063 24.9576 80.6702 25.5705 81.8749 26.7083Z",
    fill: "#004ADD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertageCheckmar);
export default __webpack_public_path__ + "static/media/certage_checkmar.023bf24ae84f11ae0dba36e969051b82.svg";
export { ForwardRef as ReactComponent };